<template>
  <div class="modal fade" id="modalOpenTicket" role="dialog">
    <div class="modal-dialog modal-xl" role="document">
      <!-- Modal content-->
      <div class="modal-content modal-dialog-centered" role="document">
        <div class="col-12 modal-container">
          <div class="modal-header">
            <a type="button" class="btn-close-modal" data-dismiss="modal">
              <ion-icon name="close"></ion-icon>
            </a>
            <span class="title-modal">
              <ion-icon name="bag-add-outline"></ion-icon>
              Abrir Ticket
            </span>
            <span class="subtitle-modal">Preencha os campos para abrir um ticket</span>
          </div>
        </div>
        <div class="container-fluid">
          <div class="col-md-12 input-group-form">
            <form class="form-general">
              <div class="col-md-6 size-input input-1">
                <label>Título<span class="danger-mandatory"> *</span></label>
                <div class="input-1-form">
                  <input v-model="dataCode.title" maxlength="200" type="text" id="title" name="title"
                         placeholder="Digite um título"/>
                  <ion-icon name="arrow-undo-outline"></ion-icon>
                </div>
              </div>
              <div class="col-md-6 size-input select-2">
                <label>Empresa<span class="danger-mandatory"> *</span>
                  <input-checkbox :is-checked="false" col="0" label="Pesquisar desativadas"
                                  @valueCheckbox="value => companyDisabled = value"/>
                </label>
                <div class="select-2-form">
                  <autocomplete :value="listCompanyFiltered" :type="1"/>
                </div>
              </div>
              <div class="col-md-6 size-input input-3">
                <label>E-mail do Cliente</label>
                <div class="input-3-form">
                  <input v-model="dataCode.clientEmail" type="text" id="email" name="email"
                         placeholder="Digite um email"/>
                  <ion-icon name="arrow-undo-outline"></ion-icon>
                </div>
              </div>
              <div class="col-md-6 size-input input-4">
                <label>Link externo</label>
                <div class="input-4-form">
                  <input v-model="dataCode.externalLink" type="text" id="link" name="link"
                         placeholder="Digite um link"/>
                  <ion-icon name="arrow-undo-outline"></ion-icon>
                </div>
              </div>
              <!--              <div class="col-md-12 padding-null tag-group">-->
              <!--                <label>Tags<span class="danger-mandatory"> *</span></label>-->
              <!--                <br>-->
              <!--                <div class="col-md-3 checklist" v-for="(ts, index) in listFilters.tags">-->
              <!--                  <input type="checkbox" v-model="dataCode.tagIds" v-bind:id="'tags'+index" v-bind:name="'tags'+index"-->
              <!--                         v-bind:value="ts.id"/>-->
              <!--                  <label v-bind:for="'tags'+index">{{ ts.name }}</label>-->
              <!--                </div>-->
              <!--              </div>-->
              <div class="col-md-6 size-input select-5">
                <input-multi-select-own col="0" label="Responsáveis" is-name="true" :is-required="true"
                                        :list-items="listFilters.responsibles"
                                        @selectedString="value => dataCode.responsibleIds = value"/>
              </div>
              <div class="col-md-6 size-input input-6">
                <label>Anexo</label>
                <div class="input-6-form">
                  <input @change="onAddAttachments" type="file" id="file" name="file" multiple/>
                </div>
              </div>
              <div class="col-md-6 size-input select-7">
                <div class="input-group input-with-date-filter">
                  <label>Prazo de entrega</label>
                  <datepicker ref="programaticOpen3" v-model="dataCode.deadLine" :language="ptBR"
                              :format="customFormatter" :clear-button="true" class="datepicker"/>
                  <i v-on:click="openCalendar3()" class="fa fa-calendar" aria-hidden="true"></i>
                </div>
              </div>
              <div class="col-md-6 size-input select-8">
                <label>Etapa<span class="danger-mandatory"> *</span></label>
                <div class="select-8-form">
                  <select v-model="dataCode.stageId" id="stageId">
                    <option value="">Selecione</option>
                    <option v-for="(ci, index) in listFilters.stages" v-bind:id="'stages'+index"
                            v-bind:name="'stages'+index" v-bind:value="ci.id">
                      {{ ci.name }}
                    </option>
                  </select>
                  <ion-icon name="chevron-down-outline"></ion-icon>
                </div>
              </div>
              <div class="textarea padding-null col-md-12 form-group">
                <label>Descrição<span class="danger-mandatory"> *</span></label>
                <textarea v-model="dataCode.description" class="form-control" id="description" rows="15"
                          cols="10"></textarea>
              </div>
            </form>
          </div>
        </div>
        <div class="modal-footer">
          <button v-on:click="createTicket()" type="submit" class="btn btn-register">
            <span v-if="!loadingChangeModal">Abrir ticket</span>
            <div class="loading-btn" v-else>
              <div class="spinner-btn">
                <div class="rect1"></div>
                <div class="rect2"></div>
                <div class="rect3"></div>
                <div class="rect4"></div>
                <div class="rect5"></div>
              </div>
            </div>
          </button>
          <button v-on:click="closeModal()" class="close-btn">Cancelar</button>
          <span v-if="errorTitle" class="error-msg">{{ errorTitle }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  CREATE_TICKET,
  UPLOAD_INFO_PROD,
} from "../../../urlConfig";

import {
  REQUEST_SERVICE
} from "../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../requestConfig";
import ptBR from "vuejs-datepicker/dist/locale/translations/pt-BR";
import datepicker from "vuejs-datepicker";
import moment from "moment";
import autocomplete from "../components/inputs/inputAutocomplete.vue";

import swal from "sweetalert";
import {ALERT_SERVICE} from "../../../msgAlertService";
import InputMultiSelectOwn from "../components/inputs/inputMultiSelectOwn.vue";
import InputCheckbox from "../components/inputs/inputCheckbox.vue";
import {target} from "vuelidate/lib/params";

export default {
  name: "modalOpenTicket",
  props: ["dataCompanyModal"],
  components: {
    InputMultiSelectOwn,
    InputCheckbox,
    datepicker,
    autocomplete,
  },

  data() {
    return {
      ptBR: ptBR,
      loadingChangeModal: false,
      listFilters: {},
      dataLog: [],
      dataCode: {
        tagIds: [],
        title: "",
        stageId: "",
        companyId: "",
        clientEmail: "",
        externalLink: "",
        responsibleIds: "" && [],
        attachments: [],
        deadLine: '',
        description: "Detalhes da solicitação: \n" +
          "\n" +
          "Qual a divergência: \n" +
          "\n" +
          "Descrever o problema: \n" +
          "\n" +
          "Como deveria ser: \n" +
          "\n" +
          "Nome de colaboradores e ID: \n" +
          "\n" +
          "Data do ocorrido: \n" +
          "\n" +
          "Deve ser feita normalização retroativa? Se sim, para qual data e será para toda empresa? \n" +
          "\n" +
          "*Anexar imagens e vídeos se houver.",
        whoCreatedId: JSON.parse(
          window.localStorage.getItem("mamUserMasterInfo")
        ).id,
        ticketProjectId: 1,
      },
      errorTitle: "",
      countFiles: 0,
      companyDisabled: false,
      listCompanyFiltered: {},
      locationReload: false
    };
  },
  watch: {
    dataCompanyModal: function (val) {
      this.listFilters = val.listFilters;
      if (this.companyDisabled)
        this.listCompanyFiltered = this.listFilters.companies;

      if (val.reload)
        this.locationReload = val.reload;

      this.listCompanyFiltered = this.listFilters.companies.filter(obj => obj.active === true)
    },
    companyDisabled(newValue, oldValue) {
      this.changeValueEmployees(newValue)
    }
  },
  methods: {
    changeValueEmployees(value) {
      if (value) {
        this.listCompanyFiltered = this.listFilters.companies
      } else {
        this.listCompanyFiltered = this.listFilters.companies.filter(obj => obj.active === true);
      }
    },
    openCalendar3: function () {
      this.$refs.programaticOpen3.showCalendar();
    },
    customFormatter(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    closeModal() {
      this.$route.params.selectedIdTicket = '';
      $("#modalOpenTicket").modal("toggle");
    },
    createTicket() {
      this.errorTitle = "";
      this.dataCode.companyId = this.$route.params.selectedIdTicket

      if (
        this.dataCode.title &&
        this.dataCode.tagIds &&
        this.dataCode.stageId &&
        this.dataCode.companyId &&
        this.dataCode.responsibleIds &&
        this.dataCode.description
        // this.dataCode.deadLine
      ) {
        if (this.dataCode.deadLine)
          this.dataCode.deadLine = moment(this.dataCode.deadLine).format("YYYY-MM-DD");

        this.loadingChangeModal = true;
        UTIL_SERVICE.console("DATA SEND:", this.dataCode);
        REQUEST_SERVICE.post(CREATE_TICKET, this.dataCode)
          .then((response) => {
            UTIL_SERVICE.console("RESULT CREATE_TICKET:", response.data);

            this.loadingChangeModal = false;
            $("#modalOpenTicket").modal("hide");

            if (this.locationReload) {
              window.open("/lista-de-ticket/" + response.data.id, "_blank");
              location.reload();
            } else {
              window.location.href = "/lista-de-ticket/" + response.data.id;
            }

            this.selectedId = '';

            swal("Aviso", "Ticket criado com sucesso.", "success");
          })
          .catch((reason) => {
            this.loadingChangeModal = false;
            $("#modalOpenTicket").modal("hide");
            swal("Aviso", "Entre em contato com a equipe de DEV.", "error");
          });
      } else {
        this.errorTitle = 'Preencha todos os campos com *';
      }
    },
    onAddAttachments(e) {
      this.loadingAttach = true;

      let files = e.target.files;
      let obj = [];

      if (!files.length)
        return;

      for (let c = 0; c < files.length; c++) {

        let fileAttach = files[c];

        UTIL_SERVICE.console("FILE SEND: ", fileAttach);
        if (fileAttach.size <= 3597152) {
          REQUEST_SERVICE.fileUpload(UPLOAD_INFO_PROD, fileAttach).then((response) => {
            UTIL_SERVICE.console("RESULT UPLOAD_INFO_PROD: ", response);

            obj.push(
              {
                fileUri: response.data,
                fileName: fileAttach.name,
                id: ''
              }
            )
          });
        } else {
          swal("Aviso", "Não foi possivel realizar o envio da imagem.\n\n Motivo: arquivo muito grande por favor enviar um arquivo menor que 3.5MB.", "warning");
        }
      }

      return this.dataCode.attachments = obj
    },
  }
};
</script>

<style lang="scss">
$border-purple: #7B61FF;
$classic-white: #ffffff;
$classic-input: #EEF2F7;
$classic-btn-closer: #D5DFEB;
$light-grey: #969696;
$light-black: #3A424E;
$light-blue: #2F23D6;
$light-blue-hover: #251bad;
$light-purple: #A313BB;
$light-pink: #FF2CC4;
$light-orange: #FF9900;
$light-yellow: #F9CA04;
$light-red: #FF445D;
$light-green: #2ACC6B;
$light-green-hover: #3fb55e;
$light-green-yellow: #a1e80a;
$light-cyan: #00B6DE;
$black: #191919;
$transp-grey: #E6E9EC;

$colors: (classic-white: #ffffff !important,
  classic-input: #EEF2F7 !important,
  light-grey: #969696 !important,
  light-black: #3A424E !important,
  light-blue: #2F23D6 !important,
  light-purple: #A313BB !important,
  light-pink: #FF2CC4 !important,
  light-orange: #FF9900 !important,
  light-red: #FF445D !important,
  light-green: #2ACC6B !important,
  light-cyan: #00B6DE !important,
);

@mixin gen-props($prefix, $property) {

  @each $color-name,
  $color in $colors {
    .#{$prefix}-#{$color-name} {
      #{$property}: $color
    }
  }
}

@include gen-props("border", "border-color");
@include gen-props("text", "color");
@include gen-props("bg", "background");

#modalOpenTicket {
  z-index: 1041 !important;

  .modal-dialog {
    width: 90rem;

    .modal-content {
      box-shadow: none !important;
      border: none !important;
      border-radius: 10px !important;
      padding: 20px 30px;

      .modal-container {
        .modal-header {
          position: relative;
          border: none;
          padding: 0;

          .btn-close-modal {
            position: absolute;
            right: 0;
            top: 0;
            height: 21px;
            color: var(--high-blue);

            &:hover {
              color: #201987;
            }

            ion-icon {
              font-size: 21px;

            }
          }

          .title-modal {
            display: flex;
            align-items: flex-start;
            font-size: 18px;
            font-weight: 700;
            color: var(--classic-black);

            ion-icon {
              margin-right: 5px;
              font-size: 23px;
              color: var(--dark-gray);
            }
          }

          .subtitle-modal {
            font-size: 14px;
            font-weight: 400;
            color: var(--dark-gray);
          }
        }
      }

      .container-fluid {
        padding: 0;
        margin-top: 25px;

        .input-group-form {
          padding: 0;
          border: none;

          .size-input {
            padding: 0;
            width: 48%;
          }

          .input-1 {
            margin-right: 15px;

            label {
              font-size: 14px;
              font-weight: 400;
              color: var(--border-gray);
            }

            .input-1-form {
              display: flex;
              position: relative;

              ion-icon {
                position: absolute;
                right: 10px;
                top: 10px;
                font-size: 16px;
                color: var(--dark-gray);
              }

              input {
                width: 100%;
                background: #EEF2F7;
                border-radius: 4px !important;
                padding: 6px 12px;
                border: 1px solid #EEF2F7;
                transition: .2s;

                font-size: 16px;
                font-weight: 400;
                color: var(--dark-gray);

                &::placeholder {
                  font-size: 16px;
                  font-weight: 400;
                  color: var(--dark-gray);
                }

                &:hover {
                  transition: .2s;
                  border: 1px solid #cacaca;
                }

                &:focus-visible {
                  outline: none;
                  transition: .2s;
                  border: 1px solid #cacaca;

                  &::placeholder {
                    transition: .1s;
                    color: #EEF2F7;
                  }
                }
              }
            }
          }

          .select-2 {
            margin-left: 15px;

            label {
              display: flex;
              gap: 4px;
              font-size: 14px;
              font-weight: 400;
              color: var(--border-gray);
            }

            .select-2-form {
              position: relative;
              margin-top: -20px;

              select {
                width: 100%;
                background: #EEF2F7;
                border-radius: 4px !important;
                padding: 6px 12px;
                border: 1px solid #EEF2F7;
                transition: .2s;
                font-size: 16px;
                font-weight: 400;
                color: var(--dark-gray);
                cursor: pointer;

                -webkit-appearance: none;
                -moz-appearance: none;
                appearance: none;

                &::placeholder {
                  font-size: 16px;
                  font-weight: 400;
                  color: var(--dark-gray);
                }

                &:hover {
                  transition: .2s;
                  border: 1px solid #cacaca;
                }

                &:focus-visible {
                  outline: none;
                  transition: .2s;
                  border: 1px solid #cacaca;

                  &::placeholder {
                    transition: .1s;
                    color: #EEF2F7;
                  }
                }
              }
            }
          }

          .input-3 {
            margin-top: 15px;
            margin-right: 15px;

            label {
              font-size: 14px;
              font-weight: 400;
              color: var(--border-gray);
            }

            .input-3-form {
              display: flex;
              position: relative;

              ion-icon {
                position: absolute;
                right: 10px;
                top: 10px;
                font-size: 16px;
                color: var(--dark-gray);
              }

              input {
                width: 100%;
                background: #EEF2F7;
                border-radius: 4px !important;
                padding: 6px 12px;
                border: 1px solid #EEF2F7;
                transition: .2s;

                font-size: 16px;
                font-weight: 400;
                color: var(--dark-gray);

                &::placeholder {
                  font-size: 16px;
                  font-weight: 400;
                  color: var(--dark-gray);
                }

                &:hover {
                  transition: .2s;
                  border: 1px solid #cacaca;
                }

                &:focus-visible {
                  outline: none;
                  transition: .2s;
                  border: 1px solid #cacaca;

                  &::placeholder {
                    transition: .1s;
                    color: #EEF2F7;
                  }
                }
              }
            }
          }

          .input-4 {
            margin-top: 15px;
            margin-left: 15px;

            label {
              font-size: 14px;
              font-weight: 400;
              color: var(--border-gray);
            }

            .input-4-form {
              display: flex;
              position: relative;

              ion-icon {
                position: absolute;
                right: 10px;
                top: 10px;
                font-size: 16px;
                color: var(--dark-gray);
              }

              input {
                width: 100%;
                background: #EEF2F7;
                border-radius: 4px !important;
                padding: 6px 12px;
                border: 1px solid #EEF2F7;
                transition: .2s;

                font-size: 16px;
                font-weight: 400;
                color: var(--dark-gray);

                &::placeholder {
                  font-size: 16px;
                  font-weight: 400;
                  color: var(--dark-gray);
                }

                &:hover {
                  transition: .2s;
                  border: 1px solid #cacaca;
                }

                &:focus-visible {
                  outline: none;
                  transition: .2s;
                  border: 1px solid #cacaca;

                  &::placeholder {
                    transition: .1s;
                    color: #EEF2F7;
                  }
                }
              }
            }
          }

          .select-5 {
            margin-top: 15px;
            margin-right: 15px;
            z-index: 2;

            .input-multiselect {
              .input {
                .show_values_select {
                  span {
                    button {
                      ion-icon {
                        margin-left: -5px;
                      }
                    }
                  }
                }
              }
            }
          }

          .input-6 {
            margin-top: 15px;
            margin-left: 15px;

            label {
              font-size: 14px;
              font-weight: 400;
              color: var(--border-gray);
            }

            .input-6-form {
              display: flex;
              position: relative;

              ion-icon {
                position: absolute;
                right: 10px;
                top: 10px;
                font-size: 16px;
                color: var(--dark-gray);
              }

              input {
                width: 100%;
                background: #EEF2F7;
                border-radius: 4px !important;
                padding: 6px 12px;
                border: 1px solid #EEF2F7;
                transition: .2s;

                font-size: 16px;
                font-weight: 400;
                color: var(--dark-gray);

                &::placeholder {
                  font-size: 16px;
                  font-weight: 400;
                  color: var(--dark-gray);
                }

                &:hover {
                  transition: .2s;
                  border: 1px solid #cacaca;
                }

                &:focus-visible {
                  outline: none;
                  transition: .2s;
                  border: 1px solid #cacaca;

                  &::placeholder {
                    transition: .1s;
                    color: #EEF2F7;
                  }
                }

                &:focus {
                  outline: none;
                }
              }
            }
          }

          .select-7 {
            margin-top: 15px;
            margin-right: 15px;
            z-index: 1;
          }

          .select-8 {
            margin-top: 15px;
            margin-left: 15px;

            label {
              font-size: 14px;
              font-weight: 400;
              color: var(--border-gray);
            }

            .select-8-form {
              position: relative;

              ion-icon {
                position: absolute;
                right: 10px;
                top: 11px;
                font-size: 16px;
                color: var(--dark-gray);
                cursor: pointer;
                pointer-events: none;


              }

              select {
                width: 100%;
                background: #EEF2F7;
                border-radius: 4px !important;
                padding: 6px 12px;
                border: 1px solid #EEF2F7;
                transition: .2s;
                font-size: 16px;
                font-weight: 400;
                color: var(--dark-gray);
                cursor: pointer;

                -webkit-appearance: none;
                -moz-appearance: none;
                appearance: none;

                &::placeholder {
                  font-size: 16px;
                  font-weight: 400;
                  color: var(--dark-gray);
                }

                &:hover {
                  transition: .2s;
                  border: 1px solid #cacaca;
                }

                &:focus-visible {
                  outline: none;
                  transition: .2s;
                  border: 1px solid #cacaca;

                  &::placeholder {
                    transition: .1s;
                    color: #EEF2F7;
                  }
                }
              }
            }
          }

          .input-with-date-filter {
            .vdp-datepicker {
              width: 100%;
              background: #EEF2F7;
              border-radius: 4px !important;
              border: 1px solid #EEF2F7;
              transition: .2s;

              font-size: 16px;
              font-weight: 400;
              color: var(--dark-gray);

              &__clear-button {
                position: absolute;
                top: -28px;
                right: 28px;
              }

              &::placeholder {
                font-size: 16px;
                font-weight: 400;
                color: var(--dark-gray);
              }

              &:hover {
                transition: .2s;
                border: 1px solid #cacaca;
              }

              &:focus-visible {
                outline: none;
                transition: .2s;
                border: 1px solid #cacaca;

                &::placeholder {
                  transition: .1s;
                  color: #EEF2F7;
                }
              }
            }

            i {
              z-index: 10055;
            }
          }

          .textarea {
            margin-top: 15px;

            textarea {
              min-height: 15rem !important;
              max-height: 15rem !important;
              min-width: 100% !important;
              max-width: 100% !important;

              border-radius: 10px !important;
              resize: none;
            }
          }

          .tag-group {
            margin-top: 15px;
            margin-bottom: 15px;

            .checklist {
              padding: 0 0.5rem 0 0 !important;

              label {
                font-size: 13px !important;
              }
            }
          }
        }
      }

      .modal-footer {
        display: flex;
        justify-content: flex-start;
        flex-direction: row-reverse;
        align-items: center;

        margin-top: 15px;
        text-align: center !important;
        border: none;
        padding: 0;

        .close-btn {
          border-radius: 4px !important;
          background-color: $classic-btn-closer;
          color: $light-black !important;
          padding: 9px 60px 9px 60px;
          font-weight: 500;
          font-size: 14px;
          text-align: center;
          border: none;
          margin-right: 10px;
          transition: .2s;

          &:hover {
            background-color: #bbbec2fc;
          }
        }

        .btn-register {
          border-radius: 4px !important;
          background-color: $light-blue;
          padding: 9px 52px 9px 52px;
          text-align: center;
          color: #fff;
          border: none;
          transition: .2s;

          &:hover {
            background-color: #20179e;
          }

          span {
            font-weight: 500;
            font-size: 14px;
          }
        }
      }
    }

    @media only screen and (max-width: 991px) {
      width: 70rem;
    }
  }

  .error-msg {
    font-size: 14px;
    color: #e74a4e;
    margin-right: 16px;
  }

  .danger-mandatory {
    color: var(--light-red);
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/modals/modalOpenTicket.vue